<h1>Mock Login</h1>
<p>This page is a placeholder so that you can use a mock token to authenticate into the system.</p>
<p>Ensure you have the param jwt in the url.</p>
<p>(base-url)/mock-login?jwt=(your-token)</p>
